<jqxWindow #form [width]="750" [height]="490" [zIndex]="100" [theme]="environment.tema"
  [isModal]="false" [position]="getFormPos(form)" [showCloseButton]="true" [showCollapseButton]="true"
  [resizable]="false" (onClose)="onClose()" [title]="translate('Ficha_ciudadano')">

  <div class="formHeader" style="overflow-x: hidden">
    {{ translate("Ficha_ciudadano") }}
  </div>

  <div class="form" style="float: left; overflow-x: hidden;">
    <div class="row" style="height: 410px;">
      <span style="width: 55%;">
        <div class="rowC">
          <fieldset>
            <legend>{{ translate('Informacion_personal_contacto') }}</legend>

            <div class="row" style="justify-content: start;">
              <span style="width: 50%; clear: both">
                <div style="margin-top: 5px;">
                  {{ translate("Fecha_creacion") }}
                </div>
                <jqxInput [ngModel]="formatDateTime(ciudadano.fechaCreacion)" [width]="'100%'"
                  [disabled]="true" [rtl]="true">
                </jqxInput>
              </span>
              <span style="width: 50%;">
                <div style="margin-top: 5px; clear: both">
                  <br>
                </div>
                <div style="float: left;">
                  <input [(ngModel)]="ciudadano.estadoValidacion" type="checkbox" (change)="onChangeValidado($event)" />
                  {{translate('Validado')}}
                </div>
              </span>
            </div>

            <div class="row" style="justify-content: start;">
              <span style="width: 50%;">
                <div style="margin-top: 5px; clear: both;">
                  {{ translate("Nombre") }}
                </div>
                <jqxInput [(ngModel)]="ciudadano.nombre" [width]="'100%'">
                </jqxInput>
              </span>
              <span style="width: 50%;">
                <div style="margin-top: 5px; clear: both;">
                  {{ translate("Apellidos") }}
                </div>
                <jqxInput [(ngModel)]="ciudadano.apellidos" [width]="'100%'">
                </jqxInput>
              </span>
            </div>

            <div class="row" style="justify-content: start;">
              <span style="width: 40%;">
                <div style="margin-top: 5px; clear: both">
                  {{ translate("Telefono") }}
                </div>
                <jqxInput [(ngModel)]="ciudadano.telefono" [rtl]="true" [width]="'100%'">
                </jqxInput>
              </span>
              <span style="width: 60%;">
                <div style="margin-top: 5px; clear: both">
                  {{ translate("Correo_electronico") }}
                </div>
                <jqxInput [(ngModel)]="ciudadano.correoElectronico" (focusout)="checkCiudadano($event)" [width]="'100%'">
                </jqxInput>
                <div [hidden]="!ciudadanoExist || ciudadano.id" style="color: red;">{{ translate('Existe_ciudadano_email') }}</div>
              </span>
            </div>
          </fieldset>

          <fieldset>
            <legend>{{ translate('Informacion_vivienda') }}</legend>

            <div class="row" style="justify-content: start;">
              <span style="width: 65%;">
                <div style="margin-top: 5px; clear: both">
                  {{ translate("Numero_catastro") }}
                </div>
                <jqxInput [(ngModel)]="ciudadano.numeroCatastro" [width]="'100%'">
                </jqxInput>
              </span>

              <span style="width: 35%;">
                <div style="margin-top: 5px; clear: both">
                  {{ translate("Codigo_postal") }}
                </div>
                <jqxInput [(ngModel)]="ciudadano.codigoPostal" [width]="'100%'" [rtl]="true">
                </jqxInput>
              </span>
            </div>

            <div class="row">
              <span style="width: 55%;">
                <div style="margin-top: 5px; clear: both">
                  {{ translate("Direccion") }}
                </div>
                <jqxInput [(ngModel)]="ciudadano.direccion" [width]="'100%'">
                </jqxInput>
              </span>

              <span style="width: 45%;">
                <div style="margin-top: 5px; clear: both">
                  {{ translate("Municipio") }}
                </div>
                <jqxInput [(ngModel)]="ciudadano.municipio" [width]="'100%'">
                </jqxInput>
              </span>
            </div>

            <div class="row">
              <span style="width: 45%;">
                <div style="margin-top: 5px; clear: both">
                  {{ translate("Provincia") }}
                </div>
                <jqxInput [(ngModel)]="ciudadano.provincia" [width]="'100%'">
                </jqxInput>
              </span>

              <span style="width: 55%;">
                <div style="margin-top: 5px; clear: both">
                  {{ translate("Comunidad_autonoma") }}
                </div>
                <jqxInput [(ngModel)]="ciudadano.comunidadAutonoma" [width]="'100%'">
                </jqxInput>
              </span>
            </div>
          </fieldset>
        </div>
      </span>

      <span style="width: 45%;">
        <app-ciudadanos-tarjetas [ciudadano]="ciudadano" [guardar]="guardar"></app-ciudadanos-tarjetas>
      </span>
    </div>

    <div style="
        position: absolute;
        bottom: 5px;
        left: 0px;
        margin-top: 23px;
        clear: both;
      ">

      <jqxButton style="float: left; margin-left: 5px" [width]="100" [height]="26"
        [textImageRelation]="'imageBeforeText'" [textPosition]="'left'" [imgSrc]="'/assets/images/save.png'"
        (onClick)="onGuardar($event)" [value]="translate('Guardar')">
      </jqxButton>
    </div>
  </div>
</jqxWindow>
